import { ROLES } from '@moal/api'
import { useContext, useEffect, useState } from 'react'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import { getRoles } from '../../../utils/APIs/roles'
import { getUserByEmail, putUserMod } from '../../../utils/APIs/users'
import InitializeRoles from './initializeRoles'

const InitializeSettings = () => {
  return (
    <div className="flex flex-col gap-2">
      <InitializeRoles />
      <InitializeAdmin />
    </div>
  )
}

const InitializeAdmin = () => {
  const { updateSetting } = useContext(SiteConfigContext)
  const [adminRole, setAdminRole] = useState()
  const [email, setEmail] = useState('')
  const [userID, setUserID] = useState()

  useEffect(() => {
    loadRoles()
  }, [])

  const loadRoles = async () => {
    const response = await getRoles()
    if (response && response.status === 200) {
      const admin = response.data.find((role) => role.role === ROLES.ADMIN)
      if (admin) {
        setAdminRole(admin._id)
      }
    }
  }

  const handleGetUser = async (e) => {
    e.preventDefault()
    if (email) {
      const response = await getUserByEmail(email)
      if (response && response.status === 200 && response.data) {
        setUserID(response.data._id)
      }
    }
  }

  const handleSetAdmin = async () => {
    const response = await putUserMod(userID, 'role', adminRole)
    if (response && response.status === 200) {
      await updateSetting(SETTINGS.SETUP_COMPLETE, true)
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <p>ADMIN ROLE ID: {adminRole}</p>
      <p>USER ID: {userID}</p>
      {!adminRole && <p>Initialize Roles First!</p>}
      {adminRole && (
        <div>
          <form
            onSubmit={handleGetUser}
            autoComplete="off"
            className="flex focus-within:z-10 gap-2"
          >
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input w-fit"
              placeholder="User Email"
            />
            <button
              type="submit"
              aria-label="Get User"
              className="button-confirm w-fit relative inline-flex items-center gap-x-1.5 rounded-r px-3 py-2 flex-shrink-0"
            >
              Get User
            </button>
          </form>
          <button
            onClick={() => handleSetAdmin()}
            aria-label="Set Admin"
            className="button-confirm w-fit"
            disabled={!userID}
          >
            Set Admin
          </button>
        </div>
      )}
    </div>
  )
}

export default InitializeSettings
